import * as $ from 'jquery'
import 'bootstrap'

/**
 * SearchAutoComplete Module
 */
const SearchAutoComplete = (function() {
    var Constructor = function(element, baseUrl, getLiData, getLi) {
        // ================== PRIVATE VAR ================== //
        var _baseUrl = baseUrl;
        var _lastToken = 0;
        var _inputText = $(element).find('input');
        var _defaultInfo = $(element).find('.default-info');
        var _resultContainer = $(element).find('ul');
        var _getLiData = getLiData || _getLiData_super;
        var _getLi = getLi || _getLi_super;

        _inputText.on('keydown', _onKeyDown);
        _inputText.on('keyup', _onKeyUp);
        _inputText.on('focus', _onFocus);

        // ================== PRIVATE METHOD ================== //
        function _onFocus(event) {
            $(event.currentTarget).val('');
            _doSearch(event.currentTarget.value);
        }

        function _onKeyDown(event) {
            if(event.keyCode == 13) {
                event.preventDefault()
                /* Select first choice if any */
                let choices = _resultContainer.find('[data-value]')
                if(choices.length > 0) {
                    choices[0].click()
                }
                return false
            }
        }

        function _onKeyUp(event) {
            _lastToken += 1;
            var currentToken = _lastToken;
            window.setTimeout(function() {
                if (currentToken == _lastToken)
                    _doSearch(event.currentTarget.value);
            }, 150);
        }

        function _doSearch(query) {
            _toogleDefaultLabel(query);
            var url = _baseUrl + '?query=' + query;
            $.get(url, _onGetResults);
        }

        function _onGetResults(data) {
            var resultList = [];
            for (var i = 0; i < data.length; i++){
                resultList.push(_getLi(data[i]));
            }
            _resultContainer.html(resultList.join(''));
        }

        function _getLi_super(data) {
            return '<li>' + _getLiData(data) + '</li>';
        }

        function _getLiData_super(data) {
            return '<a href="' + data.search_url + '">' + data.name + '</a>'
        }

        function _toogleDefaultLabel(query) {
            _defaultInfo.toggle(query.length < 2);
        }
    };
    return Constructor;
})();


/**
 * Form Select Module
 */
const FormSelect = (function() {
    var Constructor = function(element) {
        // ================== PRIVATE VAR ================== //
        var _inputText = $(element).find('input[type=hidden]');
        var _displayContainer = $(element).find('.form-control, .autocomplete-as-select');
        var _collapse = $(element).find('.collapse');
        var _options = $(element).find('.form-option');
        var _span = $(element).find('input.form-control');
        var _remove = $(element).find('.remove');
        $(element)[0].oldLabels = {};

        if ($(element).find('ul').find('.selected').length) {
            var choice = $(element).find('ul').find('.selected');
            _selectChoice(choice.html(), choice.data('value'));
        }

        // ================== PRIVATE METHOD ================== //
        function _selectChoice(label, value) {
            if (_displayContainer[0].tagName != 'INPUT')
                _displayContainer.html(label);
            else
                _displayContainer.val(label);
            _inputText.val(value);
            _inputText.text(value);
            $(element)[0].oldLabels[value] = label;
        }

        function _selectOldValue(value) {
            _selectChoice($(element)[0].oldLabels[value], value);
        }

        // ================== EVENT METHOD ================== //
        function _onChoiceClick(event) {
            event.preventDefault()
            var choice = $(event.target);
            if (!choice.data('value')) { 
                if(choice.parent().data('value')) {
                    choice = choice.parent()
                } else {
                    return;
                }
            }

            if(choice.data('label') != undefined)
                _selectChoice(choice.data('label'), choice.data('value'));
            else
                _selectChoice(choice.html(), choice.data('value'));

            _inputText.trigger('change');
            _collapse.collapse('hide');
        }

        function _onCollapseOpen() { $(element).addClass('open'); }

        function _onCollapseClose() { $(element).removeClass('open'); }

        function _onSpanClick(event) {
            event.stopPropagation()
            _collapse.collapse('show');
        }

        function _onDocumentClick(event) {
            event.stopPropagation()
            if (!$(event.target).is(_span)) {
                _collapse.collapse('hide');
            }
        }

        function _clear() {
            if (_displayContainer[0].tagName != 'INPUT')
                _displayContainer.html(_inputText.data('placeholder'));
            else
                _displayContainer.val(_inputText.data('placeholder'));
            _inputText.val('');
            _inputText.text('');
        }

        function _onRemove() {
            _clear();
            _inputText.trigger('change');
        }

        // When choosing an option select it.
        _options.on('click', _onChoiceClick);

        // On collapse open toogle open class on parent.
        _collapse.on('show.bs.collapse', _onCollapseOpen);
        _collapse.on('hide.bs.collapse', _onCollapseClose);

        // When user click inside the field.
        _span.on('click', _onSpanClick);

        // When user click outside of the choices close it.
        $(document).on('click', _onDocumentClick);

        // If the user click on the remove X, reset.
        _remove.on('click', _onRemove);

        $(element)[0].selectOldValue = _selectOldValue;
        $(element)[0].clear = _clear;
    };
    return Constructor;
})();

/**
 * Form Select Autocomplete
 */
const FormSelectAutoComplete = (function() {
    var Constructor = function(element, base_url) {
        function getLi(data) {
            var result = '<li data-value="' + data.slug + '" class="parent">' + data.name + '</li>';
            if (data.childs) {
                for (var i = 0; i < Math.min(5, data.childs.length); i++)
                    result += '<li data-value="' + data.childs[i].slug + '" class="child">' + data.childs[i].name + '</li>';
            }
            return result;
        }
        SearchAutoComplete(element, base_url, undefined, getLi);
        FormSelect(element);
    };

    return Constructor;
})();


$(document).ready(function() {
    // Create all search autocomplete module.
    $('.search-autocomplete:not(.manual)').each(function() {
        SearchAutoComplete(this, $(this).data('url'));
    });

    // Create all select input.
    $('.form-select').each(function() {
        FormSelect(this);
    });

    // Create all select input.
    $('.form-select--autocomplete').each(function() {
        FormSelectAutoComplete(this, $(this).data('url'));
    });
});

export {FormSelect, SearchAutoComplete, FormSelectAutoComplete}


// WEBPACK FOOTER //
// ./search/static/search/js/utils/form-select.js